module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Cascader"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Cascader")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("If the options have a clear hierarchical structure, Cascader can be used to view and select them.")]), _vm._v(" "), _c('p', [_vm._v("There are two ways to expand child option items")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Child options expand when clicked")]), _vm._v(" "), _c('el-cascader', {
    attrs: {
      "placeholder": "Select",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Child options expand when hovered")]), _vm._v(" "), _c('el-cascader', {
    attrs: {
      "placeholder": "Select",
      "expand-trigger": "hover",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions2),
      callback: function($$v) {
        _vm.selectedOptions2 = $$v
      },
      expression: "selectedOptions2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('p', [_vm._v("Assigning the "), _c('code', [_vm._v("options")]), _vm._v(" attribute to an array of options renders a Cascader. The "), _c('code', [_vm._v("expand-trigger")]), _vm._v(" attribute defines how child options are expanded. This example also demonstrates the "), _c('code', [_vm._v("change")]), _vm._v(" event, whose parameter is the value of Cascader, an array made up of the values of each selected level.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("With default value")]), _vm._v(" "), _c('p', [_vm._v("If the options have a clear hierarchical structure, Cascader can be used to view and select them.")]), _vm._v(" "), _c('p', [_vm._v("There are two ways to expand child option items")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.selectedOptions3),
      callback: function($$v) {
        _vm.selectedOptions3 = $$v
      },
      expression: "selectedOptions3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('p', [_vm._v("Assigning the "), _c('code', [_vm._v("options")]), _vm._v(" attribute to an array of options renders a Cascader. The "), _c('code', [_vm._v("expand-trigger")]), _vm._v(" attribute defines how child options are expanded. This example also demonstrates the "), _c('code', [_vm._v("change")]), _vm._v(" event, whose parameter is the value of Cascader, an array made up of the values of each selected level.")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55859f06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormCascader.vue
// module id = 1388
// module chunks = 2